export default __webpack_public_path__ + "static/mercado-automotivo-mobile-a246deb1f0483b8e359fcdc70c85e35d.jpg";